export default {
  main: {
    site_id: 18770421,
    title: 'Terminal PRO Demo',
    showBetBuilderSection: true,
    terminalId: 38957,
    enableMultipleTicketPay: true,
    isTicketsCheckable: true,
    needAdminForResetPin: false,
    ticketAvailableViewMode: ['card'],
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    isWithdrawal: true,
    enableKeyboardCatching: true,
    enableThemeToggle: true,
    enableTicketTimer: true,
    restrictedAdminPrintableTicketsCount: 5,
    ticketPayoutExpirationDays: 30,
    hasDayFilter: true,
    staffPassword: '0',
    enableHeaderAdminSection: true,
    homeMediaSlides: [
      {
        type: 'boosted',
        path: '/betting/prematch/all/boosted/all/all',
      },
      {
        type: 'multiple',
        path: '/betting/prematch/all/multiples',
      },
      {
        type: 'sport',
        path: '/betting/prematch/all',
      },
    ],
    websitePasswordHash: 'c49ab5e93ba30083ed5206770dc458fcb6ce9ea12370e0441b87c2bdf787e017',

    logoSize: "105x45",
    termsAndConditions: false,
    isOutlineButton: false,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,
    availableLanguages: {
      '@replace': true,
      rus: {
        short: 'RU',
        name: 'Рус',
        region: 'UnitedKingdom',
        order: 0,
      },
      eng: {
        short: 'EN',
        name: 'Eng',
        region: 'UnitedKingdom',
        order: 1,
      },
    },
  },
  disableCashoutInHeader: true,
  env: {
    lang: 'rus',
  },
  betBuilder: {
    brandName: '',
  },
  registrationFormConfigs: {
    registrationFormSteps: [
      { name: 'personal_information' },
      { name: 'contact_information' },
      { name: 'credential_information' },
      { name: "registrationTermsAndConditions_information" },
    ],
    registrationFormFiledConfigs: {
      firstName: true,
      lastName: true,
      birthDate: true,
      country: true,
      userName: true,
      password: true,
      confirmPassword: true,
      email: true,
      phoneNumber: true,
      street: true,
      city: true,
      zipCode: true,
      rull18: true,
      termsAndConditions: true,
    },
    registrationUserName: 'userName',
  },
  routes: [
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook', 
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/results',
          name: 'Results',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/racings',
          name: 'Racing',
          enabled: false,
          icon: '',
        },
        {
          urlType: 'multiplesOfTheDay',
          name: 'Multiples of the day',
          enabled: false,
          icon: 'flash',
        },
        {
          url: 'virtuals',
          name: 'Virtuals',
          enabled: false,
          icon: 'casino-categories-VirtualBetting',
        },
        {
          urlType: 'multiplesOfTheDay',
          name: 'Multiples of the day',
          enabled: false,
          icon: 'flash',
        },
        {
          urlType: 'boostedOdds',
          name: 'Boosted Odds',
          enabled: false,
          icon: 'boosted-odd',
        },
        {
          urlType: 'today',
          name: 'Today',
          enabled: false,
          icon: 'boosted-odd',
        },
      ],
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: false,
      nestedItems: [
        {
          name: 'Casino',
          url: 'casino',
          enabled: true,
          icon: 'casino-7',
        },
        {
          name: 'Live Casino',
          url: 'liveCasino',
          enabled: true,
          icon: 'casino-categories-LotteryGames',
        },
      ],
    },
    {
      name: 'Virtual Games',
      url: 'thirdPartyGame/400002',
      type: 'virtualGames',
      enabled: false,
      nestedItems: [
        {
          url: 'thirdPartyGame/156147',
          name: 'Pascal Gaming',
          enabled: true,
          iframeFullscreen: false,
          gameId: '156147',
          icon: 'casino-categories-PGgames',
          gameWithSecondScreen: false,
          onlyInHeader: false,
        },
        {
          url: 'thirdPartyGame/400002',
          name: 'Golden Race',
          iframeFullscreen: false,
          enabled: true,
          icon: 'golden-race',
          gameId: '400002',
          gameWithSecondScreen: false,
          onlyInHeader: true,
        },
        {
          url: 'thirdPartyGame/10412176',
          name: 'Pool Masters',
          enabled: true,
          icon: 'win-cup',
          iframeFullscreen: false,
          gameId: '10412176',
          gameWithSecondScreen: false,
          hasNewLabel: true,
        },
      ],
    },
  ],
  wheelConfig: {
    enableWheel: false,
    isLoggedIn: false,
    spinRotationCount: 4,
    minSelectionsCount: 3,
    minSelectionOdd: 1.2,
    minOdd: 2.5,
    maxOdd: 10000000,
    maxStake: 10000000,
    minStake: 1,
    usageRules: {
      minOdd: 1.5,
      maxOdd: 50,
      minSelections: 2,
      maxSelections: 8,
    },
    wheelBoosts: [
      {
        name: 'Profit Boost',
        value: 10,
      },
      {
        name: 'Profit Boost',
        value: 25,
      },
      {
        name: 'Profit Boost',
        value: 20,
      },
      {
        name: 'Profit Boost',
        value: 15,
      },
      {
        name: 'Profit Boost',
        value: 35,
      },
    ],
  },
  lastTicketButtons: [
    {
      name: 'Bet tickets',
      type: 'betTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Lottery tickets',
      type: 'lotteryTicket',
      hideOnRestrictMode: true,
    },
    {
      name: 'Cash-out',
      type: 'cashoutTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Pay-out',
      type: 'payoutTicket',
      hideOnRestrictMode: false,
    },
  ],
  headerItems: [
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/virtuals',
          type: 'virtuals',
          name: 'Virtuals',
          enabled: false,
          icon: 'casino-categories-VirtualBetting',
          children: [
            {
              name: 'Games',
              url: 'betting/prematch/virtuals',
              icon: '',
            },
            {
              name: 'Results',
              url: 'betting/virtual-results',
              icon: '',
            },
          ],
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: false,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: false,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/racings',
          name: 'Racing',
          enabled: false,
          icon: 'racing-horse-grayhounds',
          children: [
            {
              name: 'Horses',
              url: 'betting/racings/horse-racing',
              icon: '',
            },
            {
              name: 'Greyhounds',
              url: 'betting/racings/greyhounds',
              icon: '',
            },
          ],
        },
        {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
        },
        {
          type: 'multiplesOfTheDay',
          name: 'Multiples of the day',
          enabled: false,
          icon: 'flash',
        },
        // {
        //   type: 'boostedOdds',
        //   name: 'Boosted Odds',
        //   enabled: false,
        //   icon: 'boosted-odd',
        // },
        {
          type: 'today',
          name: 'Today',
          enabled: false,
          icon: 'boosted-odd',
        },
      ],
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: false,
      nestedItems: [
        {
          name: 'Casino',
          type: 'casino',
          url: 'casino',
          enabled: true,
          icon: 'casino-7',
        },
        {
          name: 'Live Casino',
          type: 'liveCasino',
          url: 'liveCasino',
          enabled: true,
          icon: 'casino-categories-LotteryGames',
        },
      ],
    },
    {
      name: 'Virtual Games',
      url: 'thirdPartyGame/400002',
      type: 'virtualGames',
      enabled: false,
      nestedItems: [
        {
          url: 'thirdPartyGame/400002',
          name: 'Golden Race',
          type: 'goldenRace',
          iframeFullscreen: false,
          enabled: true,
          icon: 'golden-race',
          gameId: '400002',
          gameWithSecondScreen: false,
          onlyInHeader: true,
        },
        {
          url: 'thirdPartyGame/156147',
          name: 'Pascal Gaming',
          type: 'pascalGaming',
          enabled: true,
          iframeFullscreen: false,
          gameId: '156147',
          icon: 'casino-categories-PGgames',
          gameWithSecondScreen: false,
          onlyInHeader: false,
        },
        {
          url: 'thirdPartyGame/10412176',
          name: 'Pool Masters',
          type: 'poolMasters',
          enabled: true,
          icon: 'win-cup',
          iframeFullscreen: false,
          gameId: '10412176',
          gameWithSecondScreen: false,
          hasNewLabel: true,
        },
        {
          url: 'thirdPartyGame/112008',
          name: 'Diamond X',
          type: 'diamondX',
          hasNewLabel: true,
          icon: 'diamond-x',
          enabled: true,
          iframeFullscreen: false,
          gameId: '112008',
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112007',
          name: "Joker's Luck",
          type: 'jockersLuck',
          hasNewLabel: false,
          icon: 'jockers-luck',
          enabled: true,
          iframeFullscreen: false,
          gameId: '112007',
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112005',
          name: 'Rocket Jet',
          type: 'rocketJet',
          icon: 'rocket-jet',
          enabled: true,
          iframeFullscreen: false,
          gameId: '112005',
          onlyInHeader: true,
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112002',
          name: 'Book of 6',
          type: 'bookOf6',
          icon: 'book-of-six',
          enabled: true,
          iframeFullscreen: false,
          gameId: '112002',
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112001',
          name: 'Loto',
          type: 'loto',
          icon: 'loto',
          enabled: true,
          iframeFullscreen: false,
          gameId: '112001',
          gameWithSecondScreen: false,
        },
      ],
    },
    {
      url: 'tickets',
      name: 'Tickets',
      enabled: true,
    },
  ],
  defaultTerminalParams: {
    pid: 18770421,
    tid: 38957,
    token: 'N7JYKg==',
    currency: 'TJS',
  },
  // defaultTerminalParams: { pid: 1001, tid: 378, token: "l54kAA==", currency: "AMD" },
  betslip: {
    enableSuperbetToggle: false,
    enableBookingBet: true,
    enableBankerBet: true,
    enableCounterOffer: true,
    bookingBetBalanceMaxLimit: 9999999,
  },

  sportsbook: {
    enableRaxshView: true,
    enablePredefinedMultiples: false,
    enableBoostedOdds: false,
    asianViewMarket: {
      Soccer: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "DOUBLE CHANCE",
              side: ["1X", "12", "X2"],
            },
            {
              display_key: "NEXTGOALTOSCORE",
              title: "NEXT GOAL TO SCORE",
              side: ["Home", "No", "Away"],
            },
          ],
          [
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both team to score",
              side: ["Yes", "No"],
            },
            {
              display_key: "DRAWNOBET",
              title: "DRAW NO BET",
              side: ["Home", "Away"],
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 1.5",
              side: ["Over", "Under"],
              base: 1.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 2.5",
              side: ["Over", "Under"],
              base: 2.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 3.5",
              side: ["Over", "Under"],
              base: 3.5,
            },
            {
              display_key: "ODD/EVEN",
              market_type: {
                "@in": ["EvenOddTotal", "FirstHalfEvenOddTotal", "SecondHalfEvenOddTotal"],
              },
              title: "Total Goals: Even/Odd",
              side: ["Even", "Odd"],
            },
            {
              display_key: "HANDICAP",
              market_type: {
                "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"],
              },
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "CARDSTOTALS",
              title: "Yellow Cards: Total",
              side: ["Over", "Under"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 1.5",
              side: ["Over", "Under"],
              base: 1.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 2.5",
              side: ["Over", "Under"],
              base: 2.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 3.5",
              side: ["Over", "Under"],
              base: 3.5,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "DOUBLE CHANCE",
              market_type: {
                "@in": ["DoubleChance", "HalfTimeDoubleChance", "SecondHalfDoubleChance",],
              },
              side: ["1X", "12", "X2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals",
              side: ["Over", "Under"],
              alt_main_order: 1,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 1.5",
              side: ["Over", "Under"],
              base: 1.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 2.5",
              side: ["Over", "Under"],
              base: 2.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 3.5",
              side: ["Over", "Under"],
              base: 3.5,
            },
          ],
          [
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both team to score",
              side: ["Yes", "No"],
            },
            {
              display_key: "DRAWNOBET",
              title: "DRAW NO BET",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              market_type: {
                "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"],
              },
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "CARDSTOTALS",
              title: "Yellow Cards: Total",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      CyberFootball: {
        prematch: [
          [{
            display_key: "WINNER",
            title: "Winner",
            side: ["P1", "X", "P2"],
          }],
        ],
        live: [
          [{
            display_key: "WINNER",
            title: "Winner",
            side: ["P1", "X", "P2"],
          }],
        ],
      },
      Tennis: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "SetHandicap",
              title: "Set Games Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["SetOverUnder", "TotalGamesOver/Under"],
              },
              title: "SET TOTAL GAMES",
              side: ["Over", "Under"],
            },
            {
              market_type: {
                "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"],
              },
              title: "TOTAL GAMES ODD OR EVEN",
              side: ["Even", "Odd"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "Handicap",
              title: "Games Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["SetOverUnder", "TotalGamesOver/Under"],
              },
              title: "TOTAL GAMES",
              side: ["Over", "Under"],
            },
            {
              market_type: {
                "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"],
              },
              title: "TOTAL GAMES ODD OR EVEN",
              side: ["Even", "Odd"],
            },
          ],
        ],
      },
      Basketball: {
        live: [
          [
            {
              title: "Overtime",
              market_type: "Overtime",
              side: ["Yes", "No"],
            },
            {
              display_key: "HANDICAP",
              title: "Points Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Match Total",
              side: ["Over", "Under"],
            },
            {
              display_key: "ODD/EVEN",
              title: "Match Total Odd/Even",
              side: ["Even", "Odd"],
            },
          ],
        ],
        prematch: [
          [
            {
              market_type: "MatchWinner2",
              // display_key: "WINNER",
              title: "Match Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Match Handicap",
              side: ["Home", "Away"],
            },
            {
              display_key: "TOTALS",
              title: "Match Total",
              side: ["Over", "Under"],
            },
            {
              display_key: "ODD/EVEN",
              title: "Match Total Odd/Even",
              side: ["Even", "Odd"],
            },
          ],
        ],
      },
      IceHockey: {
        live: [
          [
            {
              display_key: "WINNER",
              market_type: "MatchWinner3",
              title: "Match Result (Regular Time)",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "WINNER",
              title: "Winner (Regular Time)",
              side: ["P1", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "Double chance (Regular Time)",
              side: ["1X", "12", "X2"],
            },
            {
              market_type: {
                "@in": ["MatchTotal3", "PeriodTotal3"],
              },
              display_key: "TOTALS",
              title: "Total 3 Way (Regular Time)",
              side: ["Over", "Exactly", "Under"],
            },
            {
              market_type: "NextTeamToScore",
              title: "Next Team to Score",
              side: ["Home", "Away", "No"],
            },
          ],
          [
            {
              display_key: "WINNER",
              title: "Winner (With Overtime)",
              market_type: "MatchWinner2",
              side: ["P1", "P2"],
            },
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both team to score",
              side: ["Yes", "No"],
            },
            {
              market_type: {
                "@in": ["MatchTotal2", "PeriodTotal2"],
              },
              display_key: "TOTALS",
              title: "Total (Regular Time)",
              side: ["Over", "Under"],
            },
            {
              market_type: {
                "@in": ["MatchHandicap2", "PeriodHandicap2"],
              },
              display_key: "HANDICAP",
              title: "Handicap (Regular Time)",
              side: ["Home", "Away"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              market_type: "MatchWinner3",
              title: "Match Result (Regular Time)",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "WINNER",
              title: "Winner (Regular Time)",
              side: ["P1", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "Double chance (Regular Time)",
              side: ["1X", "12", "X2"],
            },
            {
              market_type: {
                "@in": ["MatchTotal3", "PeriodTotal3"],
              },
              display_key: "TOTALS",
              title: "Total 3 Way (Regular Time)",
              side: ["Over", "Exactly", "Under"],
            },
          ],
          [
            {
              display_key: "WINNER",
              title: "Winner (With Overtime)",
              market_type: "MatchWinner2",
              side: ["P1", "P2"],
            },
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both team to score",
              side: ["Yes", "No"],
            },
            {
              market_type: {
                "@in": ["MatchTotal2", "PeriodTotal2"],
              },
              display_key: "TOTALS",
              title: "Total (Regular Time)",
              side: ["Over", "Under"],
            },
            {
              market_type: {
                "@in": ["MatchHandicap2", "PeriodHandicap2"],
              },
              display_key: "HANDICAP",
              title: "Handicap (Regular Time)",
              side: ["Home", "Away"],
            },
          ],
        ],
      },
      Volleyball: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "HANDICAP",
              title: "Match points Handicap",
              side: ["Home", "Away"],
            },
            {
              market_type: "TOTALS",
              title: "Total points",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              market_type: {
                "@in": ["MatchHandicap2", "PeriodHandicap2"],
              },
              display_key: "HANDICAP",
              title: "Handicap (Regular Time)",
              side: ["Home", "Away"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              display_key: "HANDICAP",
              // market_type: "MatchTotalPointsHandicap",
              title: "Points Handicap",
              side: ["Home", "Away"],
            },
            {
              display_key: "TOTALS",
              // market_type: "MatchTotalPointsOverUnder",
              title: "Total points",
              side: ["Over", "Under"],
            },
          ],
          [
            {
              market_type: {
                "@in": ["MatchHandicap2", "PeriodHandicap2"],
              },
              display_key: "HANDICAP",
              title: "Handicap (Regular Time)",
              side: ["Home", "Away"],
            },
          ],
        ],
      },
      Pesapallo: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      IceHockey: {
        live: [
          [
            {
              display_key: "WINNER",
              market_type: "MatchWinner3",
              title: "Match Result (Regular Time)",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "Double chance (Regular Time)",
              side: ["1X", "12", "X2"],
            },
          ],
          [
            {
              display_key: "WINNER",
              title: "Match Winner (Including Overtime)",
              market_type: "MatchWinner2",
              side: ["P1", "P2"],
            },
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both Teams To Score (Regular Time)",
              side: ["Yes", "No"],
            },
            {
              market_type: {
                '@in': ['MatchTotal2', 'PeriodTotal2'],
              },
              display_key: 'TOTALS',
              title: 'Total (Regular Time)',
              side: ['Over', 'Under'],
            },
            {
              market_type: {
                '@in': ['MatchHandicap2', 'PeriodHandicap2'],
              },
              display_key: 'HANDICAP',
              title: 'Handicap (Regular Time)',
              side: ['Home', 'Away'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              market_type: "MatchWinner3",
              title: "Match Result (Regular Time)",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "Double chance (Regular Time)",
              side: ["1X", "12", "X2"],
            },
          ],
          [
            {
              display_key: "WINNER",
              title: "Match Winner (Including Overtime)",
              market_type: "MatchWinner2",
              side: ["P1", "P2"],
            },
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both Teams To Score (Regular Time)",
              side: ["Yes", "No"],
            },
            {
              market_type: {
                '@in': ['MatchTotal2', 'PeriodTotal2'],
              },
              display_key: 'TOTALS',
              title: 'Total (Regular Time)',
              side: ['Over', 'Under'],
            },
            {
              market_type: {
                '@in': ['MatchHandicap2', 'PeriodHandicap2'],
              },
              display_key: 'HANDICAP',
              title: 'Handicap (Regular Time)',
              side: ['Home', 'Away'],
            },
          ],
        ],
      },
      Handball: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      BallHockey: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Match Result',
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Futsal: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      RugbyLeague: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      RugbyUnion: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      WaterPolo: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
            },
          ],
        ],
      },
      Darts: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: "TotalSetsOver/Under",
              title: "TOTAL SETS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: "TotalSetsOver/Under",
              title: "TOTAL SETS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Chess: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      default: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
    },
  },
};
